<template>
  <div class="safe">
    <div class="header">
		<div class="header-layout">
			<h1 class="logo" id="logo">
				<a href="http://www.ddzzii.com"></a>
			</h1>
			<a class="logo-title"> {{ivActionType}} </a>
			<ul class="header-nav">
				<li class="li-first">
					<a href="">注册</a>
				</li>
				<li>
					<a href="">登录</a>
				</li>
				<li>
					<a href="/index">首页</a>
				</li>
				<li>
					<a href="">帮助中心</a>
				</li>
			</ul>
		</div>
    </div>
	<div class="content">
			<div class="maincenter">
				<div class="maincenter-box">
					<div style="width: 80%;margin:20px auto 0;font-size: 14px;border-bottom: 1px solid #b9b9b9;">请输入你需要找回登录密码的账号的手机号</div>
					<div class="form">
						<div class="form-item">
							<div class="form-item-title">手机号:</div>
							<div class="form-item-content">
								<el-input v-model.trim="name" placeholder="请输入手机号" maxlength="11" class="form-input" @blur="verifyPhone"></el-input>
							</div>
							<div class="form-item-other">忘记登录名，请点此找回登录名</div>
						</div>
						<div class="form-item">
							<div class="error">{{error}}</div>
						</div>
						<div class="form-item">
							<el-row type="flex" class="row-bg dialog-row" style="height: 40px;line-height: 40px;" justify="center"
							        :gutter="5">
							  <div class="form-item-title">校验码:</div>
							  <verify-image v-model="refreshCode" @blur="verifyCode" :form-key="formKey" class="form-input"
							                @change="code=$event"></verify-image>
							</el-row>
						</div>
						<div class="form-item">
							<div class="error">{{errors}}</div>
						</div>
						<div class="form-item submitButton">
							<el-button type="primary" @click="submitHandler">确认</el-button>
						</div>
					</div>
				</div>
			</div>
	</div>
	<footer-layout></footer-layout>
  </div>
</template>

<script>
  import VerifyImage from '@/components/fields/VerifyImage'
  import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'CheckPhone',
    components: {FooterLayout,VerifyImage},
    data() {
      return {
		  ivActionType: '找回密码',
		  name: '',
		  code: '',
		  formKey: '',
		  refreshCode: false,
		  asyncCodeVerify: false,
		  errmsg: [],
		  error: '',
		  errors: '',
		  flag: false,
      }
    },
	watch: {
	  code(nv, ov) {
	    if (nv.length === 6) {
	      this.verifyCode()
	    }
	  },
	},
    methods: {
		/**
		 * 验证验证码
		 */
		verifyCode() {
		  if (this.code.length === 6) {
		    this.$api.common.verifyImgCode(this.formKey, this.code).then(res => {
		      if (res.data === true) {
				this.errors = ''
		        this.$set(this.errmsg, 'code', '')
		        this.asyncCodeVerify = true
		      } else {
		        this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
				this.errors = '请输入正确验证码'
		        // 刷新验证码
		        this.refreshCode = true
		        this.asyncCodeVerify = false
		      }
		    })
		  } else {
			this.errors = '请输入正确验证码'
		    this.$set(this.errmsg, 'code', '验证码错误，请重新输入')
			this.asyncCodeVerify = false
		  }
		},
		/**
		 * 验证用户名是否存在
		 */
		verifyPhone() {
			this.$api.user.phoneExist(this.name).then(res => {
			  console.log(res.data)
			  if (res.code === 0) {
				  if (res.data === true) {
					console.log(res.data)
					this.error = ''
					this.flag = true
				  } else {
					this.error = '您输入的用户名有误'
					this.flag = false
				  }
			    } else {
					this.error = res.details[0]
					this.flag = false
				}
			})
		},
		submitHandler() {
			this.verifyCode()
			this.verifyPhone()
			// console.log('flag')
			// console.log(this.flag)
			// console.log('asyncCodeVerify')
			// console.log(this.asyncCodeVerify)
			if (this.flag === true && this.asyncCodeVerify === true){
				this.$router.push({path:'/verifyphone', name: 'VerifyPhone', params: {phone: this.name}})
			} else {
				return
			}
		  // 提交
		},
		
    },
    created() {
		window.localStorage.setItem('ivActionType','password_reset')
		this.$api.common.formKey().then(res => {
		  console.log(res)
		  if (res.code === 0) {
		    this.formKey = res.data
		    this.serverError = ''
		  } else {
		    this.serverError = '页面加载失败，请刷新页面'
		  }
		})
    }
  }
</script>

<style>
.form-input .el-input__inner{
	border-radius: 0px;
}
<style scoped>
	.content{
		width: 100%;
		min-height: 500px;
		border-top: 1px solid #fff;
		background-color: #fff;
	}
	.account-layout{
		margin: 0 auto;
		padding: 30px 0;
		width: 990px;
		height: auto;
	}
	.maincenter{
		margin: 0 auto;
		width: 774px;
		height: auto;
	}
	.maincenter-box {
	    padding: 20px 0;
	    background-color: #fff;
	}
	.form{
		margin-top: 30px;
		color: #6c6c6c;
	}
	.form-item{
		padding: 0 5px 20px 190px;
		zoom: 1;
		display: flex;
	}
	.form-item-title{
		font-size: 14px;
		line-height: 40px;
		margin-right: 30px;
	}
	.form-item-content{
		width: 190px;
	}
	.error{
		color: red;
		height: 20px;
	}
	.form-item-other{
		line-height: 40px;
		margin-left: 10px;
	}
</style>
